import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaDispersionPagos', NominasNominaDispersionPagos)

function NominasNominaDispersionPagos($http) {
  this.get = function (idProyecto, idNomina, idTipoPago) {
    return $http.get('/api/nominas/nomina/dispersion/pagos', {
      params: {id_proyecto: idProyecto, id_nomina: idNomina, id_tipo_pago: idTipoPago},
      schema: this.schema,
    })
  }.bind(this)

  this.schema = {
    admin: 'boolean',
    fecha_pago: 'date',
    fecha_nomina: 'date',
    importe: 'number',
    tipo_cambio: 'number',
    opciones: {
      configurar: 'boolean',
      layout_bancario: 'boolean',
      layout_h2h: 'boolean',
      vinculacion: 'boolean',
    },
    pagos: {
      id_tipo_pago: 'number',
      id_metodo_pago: 'number',
      id_moneda: 'number',
      completado: 'boolean',
      pagos_completados: 'number',
      pagos_en_proceso: 'number',
      pagos_pendientes: 'number',
      pagos_retenidos: 'number',
      total: 'number',
    },
    otros_pagos: {
      id_moneda: 'number',
      id_metodo_pago: 'number',
      id_tipo_pago: 'number',
      completado: 'boolean',
      pagos_completados: 'number',
      pagos_pendientes: 'number',
      pagos_retenidos: 'number',
      total: 'number',
    },
    transferencias: {
      id_moneda: 'number',
      id_tipo_pago: 'number',
      completado: 'boolean',
      pagos_completados: 'number',
      pagos_pendientes: 'number',
      pagos_retenidos: 'number',
      total: 'number',
    },
    pagos_retenidos: {
      id_moneda: 'number',
      id_tipo_pago: 'number',
      pagos: 'number',
      total: 'number',
    },
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Dispersion/Pagos.js